import { getAddress, isAddress, isAddressEqual, zeroAddress } from 'viem'

export function parseWithdrawalDestination(value: string): string | null {
  const trimmed = value.trim()
  if (!isAddress(trimmed)) return null

  const address = getAddress(trimmed)
  if (isAddressEqual(address, zeroAddress)) return null

  return address
}
